import PropTypes from 'prop-types';
import React from 'react';

export class CardZeroState extends React.Component {
  render() {
    return (
      <div className="row">
        <div className="col-xs-12 appointment-container">
          <div className="zero-state-container">
            <div className="zero-state-content">
              <span
                className={ 'fa ' + (this.props.stateIconCss ? this.props.stateIconCss : '') }
              >
              </span>
              <span tabIndex="0">{ this.props.zeroStateMessage }</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CardZeroState.propTypes = {
  zeroStateMessage: PropTypes.object,
  stateIconCss: PropTypes.string,
};
